import { Stack, Typography } from '@mui/material'
import React, { useMemo } from 'react'

import { type AgentSummaryResponse } from 'types/api/agents/agents'

// preserves the order of the keys in the summary
const ORDERED_SUMMARY_KEYS = ['Active', 'Warnings', 'Deactivated', 'Idle']

export const AgentsSummary: React.FC<{
  agentsSummary: AgentSummaryResponse
}> = ({ agentsSummary }) => {
  const summaryDataList = useMemo(() => {
    return ORDERED_SUMMARY_KEYS.map((key) => ({
      key,
      value: agentsSummary[key.toLowerCase()]
    }))
  }, [agentsSummary])

  return (
    <Stack direction="row" sx={{ justifyContent: 'space-evenly' }}>
      {summaryDataList.map(({ key, value }) => (
        <Stack
          key={key}
          data-testid={`agent-page-summary-${key.toLowerCase()}-agents`}
          sx={{ alignItems: 'center' }}
        >
          <Typography variant="h6">{value}</Typography>
          <Typography variant="body1">{key}</Typography>
        </Stack>
      ))}
    </Stack>
  )
}
